import { render, staticRenderFns } from "./bandstaff_userid.vue?vue&type=template&id=033c1cac&scoped=true"
import script from "./bandstaff_userid.vue?vue&type=script&lang=js"
export * from "./bandstaff_userid.vue?vue&type=script&lang=js"
import style0 from "./bandstaff_userid.vue?vue&type=style&index=0&id=033c1cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c1cac",
  null
  
)

export default component.exports